import React from 'react'
import { Wrapper, Loader } from './styles'

const Spinner = ({ className }) => (
    <Wrapper className={className}>
      <Loader />
    </Wrapper>
)

export default Spinner